import { useQuery } from '@tanstack/react-query';
import { documentApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Every document on a job, i.e. the root ("All documents") file list. */
export function useDocumentList(
  jobId: number | null | undefined,
  enabled = true,
) {
  return useQuery({
    queryKey: queryKeys.documents.list(jobId ?? -1),
    queryFn: ({ signal }) =>
      documentApiClient.listDocuments(jobId!, toCancelToken(signal)),
    enabled: enabled && jobId != null && jobId > 0,
    meta: { errorContext: 'documents' },
  });
}
